export default __webpack_public_path__ + "static/media/logotwxt.77c0fce0.png";